import React from 'react';
import { Table, Space, Popover, Tag, Button} from 'antd';
import {StarTwoTone, StarFilled} from '@ant-design/icons';
import UIFetchService from '../Service/UIFetchService';

const unknownColumn = <span style={{ color: 'gray' }}>未知</span>

class UserTable extends React.Component {

    render() {
        return <Table dataSource={this.props.dataSource} pagination={this.props.pagination} onChange={this.props.onChange}>
            <Table.Column
                title="bcz_uid"
                dataIndex="bczUid"
                key="bcz_uid"
                render={(_, record) => <Button type="link" size="small" onClick={() => this.props.onShowDetail(record.bczUid)}>{record.bczUid}</Button>} />
            <Table.Column
                title="bcz_id"
                key="bcz_id"
                dataIndex="bczId"/>
            <Table.Column
                title="cya_uid"
                key="cya_uid"
                dataIndex="cyaUid"
                render={cyaUid => cyaUid === null ? unknownColumn : <span>{cyaUid}</span>}
            />
            <Table.Column
                title="wx_open_id"
                key="wx_open_id"
                render={(_, record) => JSON.stringify(record.wxOpenIds) === '{}' ? unknownColumn :
                    <Space>{
                        Object.keys(record.wxOpenIds).map(key =>
                            <Popover
                                title="wx_open_id"
                                content={<div style={{ fontFamily: 'courier' }}>{record.wxOpenIds[key]}</div>}>
                                <Tag>{key}</Tag>
                            </Popover>)
                    }</Space>} />
            <Table.Column
                title="wx_union_id"
                key="wx_union_id"
                render={(_, record) => !record.wxUnionId ? unknownColumn : <span style={{ fontFamily: 'courier' }}>{record.wxUnionId}</span>} />
            <Table.Column
                title="电话号码"
                key="phone"
                render={(_, record) => !record.maskedPhone ? unknownColumn : <span>{record.maskedPhone}</span>} />
            <Table.Column
                title="注册时间"
                dataIndex="registerDate"
                key="registerDate" />
            {this.props.isShowOper && 
                <Table.Column title="操作" dataIndex="collect" key="collect"
                    render={(_, record) => {return !record.collect
                        ? <Button
                        type="link"
                        style={{ padding: '7px' }}
                        icon={<StarTwoTone/>}
                        onClick={()=> {
                            this.collectSave(record)
                        }}
                            ></Button>
                        :<Button
                        type="link"
                        style={{ padding: '7px' }}
                        icon={<StarFilled />}
                        onClick={()=> {
                            this.collectCancel(record)
                        }}></Button>}}
                />}
        </Table>
    }

    async collectSave(record) {
        await UIFetchService.put(`/api/v1/user_profile/users/collect/${record.bczUid}`);
        this.props.refreshTable()
    }

    async collectCancel(record) {
        await UIFetchService.delete(`/api/v1/user_profile/users/collect/${record.bczUid}`);
        this.props.refreshTable()
    }
}

export default UserTable;